import React, { Component } from 'react';
import LoginForm from "../../common/components/LoginForm/LoginForm";
import RegisterForm from "../../common/components/RegisterForm/RegisterForm";
import './login.css';

export default class Login extends Component {
  
  constructor() {
    super();
    
    this.state = {
      showLogInForm: true,
    }
  }
  
  render() {
    
    let showLogInForm = this.state.showLogInForm;
    
    return (
      <div className="login-and-register-page-warpper">
        {
          showLogInForm ?
            <LoginForm showRegisterForm={() => this._showRegisterForm()} />
            :
            <RegisterForm showLogInForm={() => this._showLogInForm()} />
        }
      </div>
    );
  }
  
  _showLogInForm() {
    this.setState({ showLogInForm: true });
  }
  
  _showRegisterForm() {
    this.setState({ showLogInForm: false });
  }
}


// WEBPACK FOOTER //
// ./src/pages/login/login.js